/*eslint-disable */
import Vue from 'vue'
var $ = window.jQuery = require('jquery');
import toast from '@/services/toast';
import {
  bus
} from '@/main';
export default {
  name: 'update-group-name',
  components: {},
  props: ['updateGroupNameID'],
  data () {
    return {
      submitted:false,
      topic:'',
    }
  },
  computed: {

  },
  mounted () {
    this.getGroupDetailsByIdFun()
  },
  methods: {
    getGroupDetailsByIdFun(){
      this.$store.dispatch('getGroupChatDetailsByIdFun', { id: this.updateGroupNameID }).then((res)=>{
        this.topic = res.data.data.name
      })
    },
    getGroupDetailsByIdAgainFun(updateGroupNameID){
      this.$store.dispatch('getGroupChatDetailsByIdFun', { id: updateGroupNameID }).then((res)=>{
        bus.$emit('updateGroupInfoDataBus', res.data.data)
      })
    },
    getGroupRoomListAgain(){
      this.$store.dispatch('getGroupChatRoomCreatedFun').then((res) => {
      })
    },
    updateGroupChatBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          var data = {
            name:this.topic,
          }
          this.$store.dispatch('updateGroupChatDetailsFun', {data:{data:data,id:this.updateGroupNameID}})
            .then((res) => { 
              toast.success(res.data.msg);
              this.getGroupDetailsByIdAgainFun(this.updateGroupNameID)
              this.getGroupRoomListAgain()
              this.updateGroupPopupDisabledFun()
              this.submitted =  false
            }).catch((err) => {
              toast.error(err.data.msg);
              this.submitted =  false
            })
          return;
        }
      })
    },
    updateGroupPopupDisabledFun(){
      $('body').removeClass('body_right_scroll_remove')
      bus.$emit('updateGroupNamePopupStateBus', false);
    }
  },
  watch:{
  }
}


